/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_StatusInputs */

const en_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription Status`)
};

const es_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de suscripción`)
};

const fr_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut de l'abonnement`)
};

const de_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnement-Status`)
};

const ja_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションの状態`)
};

const zh_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅状态`)
};

const ar_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حالة الاشتراك`)
};

const id_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Langganan`)
};

const it_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato dell'Abbonamento`)
};

const ru_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус подписки`)
};

const pt_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status da Assinatura`)
};

const ko_subscription_status = /** @type {(inputs: Subscription_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 상태`)
};

/**
* | output |
* | --- |
* | "Subscription Status" |
*
* @param {Subscription_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const subscription_status = /** @type {((inputs?: Subscription_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_status(inputs)
	if (locale === "es") return es_subscription_status(inputs)
	if (locale === "fr") return fr_subscription_status(inputs)
	if (locale === "de") return de_subscription_status(inputs)
	if (locale === "ja") return ja_subscription_status(inputs)
	if (locale === "zh") return zh_subscription_status(inputs)
	if (locale === "ar") return ar_subscription_status(inputs)
	if (locale === "id") return id_subscription_status(inputs)
	if (locale === "it") return it_subscription_status(inputs)
	if (locale === "ru") return ru_subscription_status(inputs)
	if (locale === "pt") return pt_subscription_status(inputs)
	return ko_subscription_status(inputs)
});